import store from '@/store'
import router from '@/router'
import { umamiTrackEvent } from 'utils/umami'

/**
 * Send a purchase-funnel event to Umami with venue context attached.
 * venue slug comes from the current route; venueName from the store.
 * No PII is ever included.
 * @param {String} name 'add_to_cart' | 'begin_checkout' | 'purchase'
 * @param {Object} [extra] optional extra props (e.g. { mode, table })
 */
/**
 * 向 Umami 发送下单漏斗事件,自动附带 venue 上下文。
 * venue slug 取自当前路由;venueName 取自 store。绝不带任何 PII。
 * @param {String} name 'add_to_cart' | 'begin_checkout' | 'purchase'
 * @param {Object} [extra] 可选附加属性(如 { mode, table })
 */
function trackFunnelEvent(name, extra = {}) {
  const venue = router.currentRoute?.params?.venueId || ''
  const venueName = store.state?.navTitle?.venueName || ''
  umamiTrackEvent(name, { venue, venueName, ...extra })
}

export { trackFunnelEvent }
